import styled from 'foundations-theming/utils';
import { Flex } from 'foundations-components/components/Flex';
import { AGENT, VISITOR } from 'conversations-message-history/constants/messageUses';
import { jsx as _jsx } from "react/jsx-runtime";
const BoxShadow = styled.div.withConfig({
  displayName: "LegacyPrimaryMessageContent__BoxShadow",
  componentId: "sc-147vo2r-0"
})(["inline-size:100%;box-shadow:", ";"], ({
  highlight,
  theme
}) => highlight && `0 0 0 1px ${theme.color['border-interactive-default']}, 0 0 12px 0 ${theme.color['border-interactive-default']}`);
const LegacyPrimaryMessageContent = ({
  children,
  highlight,
  use
}) => {
  const backgroundColor = use === AGENT || use === VISITOR ? 'fill-surface-default' : 'fill-tertiary-default';
  return (
    /*#__PURE__*/
    // The custom styling is necessary for this box-shadow. If refactored, this can use a Trellis Flex.
    // @bend-expect trellis-tokenized
    _jsx(BoxShadow, {
      highlight: !!highlight,
      children: /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        borderRadius: "200",
        overflow: "hidden",
        "data-test-id": "primary-message-content-wrapper",
        backgroundColor: backgroundColor,
        borderColor: "border-core-default",
        borderWidth: "100",
        borderStyle: "solid",
        paddingInline: "300",
        paddingBlock: "0",
        inlineSize: "100%",
        position: "relative",
        minBlockSize: "32px",
        children: children
      })
    })
  );
};
LegacyPrimaryMessageContent.displayName = 'LegacyPrimaryMessageContent';
export default LegacyPrimaryMessageContent;